

export function introduction_main(lang = 'ru'){
	
	switch (lang) {
		case 'ru':
			return('Прекрасная страна! Прекрасный экологичный отдых и зимой и летом. Великолепные пейзажи. Горы, море и солнце. Монастыри и средневековые  города. Дружелюбное население. Доступные цены. Недорогое хорошее вино. Аутентичная кухня. Что еще нужно человеку, чтобы хорошо отдохнуть!')
			
		case 'en':
			return('Excellent country, wonderful ecological vacation spot both in winter and in summer. Nice landscapes that combine mountains and sea. Plenty of sun. Monasteries and medieval towns. Friendly people. Affordable prices, good wine. Authentic cuisine. All you need for a great rest.')
			
		
		case 'sr':
			return ('Дивна земља! Предиван еколошки празник и зима и лето. Величанствени пејзаж. Планине, море и сунце. Манастири и средњовековни градови. Пријатна популација. Приступачне цене. Јефтино добро вино. Аутентична кухиња. Оно што је још потребна особа да се добро опусти!')
			
		case 'de':
			return ('Wundervolles Land! Schöner Urlaub im Winter und Sommer. Herrliche Landschaft. Berge, Meer und viel Sonne. Klöster und mittelalterliche Städte. Freundliche Leute. Bezahlbare Preise. Preiswerter guter Wein. Authentische Küche. Alles, was man braucht, um sich gut zu entspanne!')
			
		default:
			return ('Прекрасная страна! Прекрасный экологичный отдых и зимой и летом. Великолепные пейзажи. Горы, море и солнце. Монастыри и средневековые  города. Дружелюбное население. Доступные цены. Недорогое хорошее вино. Authentic . Что еще нужно человеку, чтобы хорошо отдохнуть!')
			
	}
		
}

export function introduction($lang = 'ru'){
	
			switch ($lang) {
				case 'ru':
					return('Апартаменты Макондо расположены в пешей доступности от аэропорта Тиват. До центра Тивата и Порто-Монтенегро 15 мин пешком. 5 минут до автобусной станции и торгового центра. Закрытая территория с зоной барбекю. За калиткой небольшой камерный пляж, что может быть особенно удобно для родителей с детьми. Бесплатно паркинг и WiFi. Туалетные  и кухонные принадлежности. Цены на бронирование на длительные сроки - по договоренности.');
					
					
				case 'en':
					return ('15 min by foot from the airport Tivat. 15 min by foot from the center of Tivat and Porto-Montenegro. 5 min from the bus station and a large supermarket. Closed secluded territory with a chill-out space in the garden with terraсe, bar and barbecue spot. Small beach right at the gate. Great for parents with kids! Parking and WiFi free. Fully equipped kitchen, including washing machine, dishwasher, etc. Price for long-term booking is negotiable.');
					
				
				case 'sr':
					return ('Апартмани Макондо налазе се на удаљености од аеродрома Тиват. До центра Тивта и Порто Црна Гора 15 минута пјешице. 5 минута до аутобуске станице и тржног центра. Затворено подручје са роштиљем. У викету, мале плаже коморе, која може бити посебно погодна за родитеље са децом. Бесплатан паркинг и WiFi, тоалетни и кухињски прибор. Цене за резервацију за дугање - споразумом.');
					
				case 'de':
					return ('Makondo Apartments befinden sich in nur wenige Gehminuten vom Flughafen Tivat. Zum Zentrum von Tivat und Porto Montenegro ist es 15 Minuten zu Fuß. 5 Minuten zur Bushaltestelle und zum Einkaufszentrum. Geschlossener Garten mit Grillbereich. Ein kleiner Strand direkt hinter den Gartentor, der für Eltern mit Kindern besonders günstig sein kann. Kostenlose Parkplätze und WLAN. WC und Küchenutensilien. Preise für die Buchung für lange Bedingungen - nach Vereinbarung.');
					
				default:
					return ('Апартаменты Макондо расположены в пешей доступности от аэропорта Тиват. До центра Тивата и Порто-Монтенегро 15 мин пешком. 5 минут до автобусной станции и торгового центра. Закрытая территория с зоной барбекю. За калиткой небольшой камерный пляж, что может быть особенно удобно для родителей с детьми. Бесплатно паркинг и WiFi. Туалетные  и кухонные принадлежности. Цены на бронирование на длительные сроки - по договоренности.');
					
			}

		
}


